import { useState } from "react";
import { Menu } from "lucide-react";
import { Routes, Route } from "react-router-dom";
import KnowledgeHub from "./pages/KnowledgeHub";
import Sidebar from "./components/Sidebar";
import TopNavbar from "./components/TopNavbar";
import LearningHub from "./pages/LearningHub";
import Home from "./pages/Home";
import Tools from "./pages/Tools";
import Announcements from "./pages/Announcements";
import WifiPasswords from "./pages/WifiPasswords";
import AttendanceDashboard from "./pages/AttendanceDashboard";
import CadenceLicense from "./pages/CadenceLicense";

function DashboardLayout() {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="flex h-screen bg-[#F5F7FA] overflow-hidden">

      {/* MOBILE OVERLAY */}
      {sidebarOpen && (
        <div
          className="fixed inset-0 bg-black/40 z-40 lg:hidden"
          onClick={() => setSidebarOpen(false)}
        />
      )}

      {/* SIDEBAR */}
      <Sidebar
        sidebarOpen={sidebarOpen}
        setSidebarOpen={setSidebarOpen}
      />

      {/* MAIN AREA */}
      <div className="flex-1 flex flex-col min-w-0">

        {/* MOBILE HEADER */}
        <div className="lg:hidden h-16 bg-white border-b flex items-center justify-between px-4 shadow-sm">

          <button
            onClick={() => setSidebarOpen(true)}
            className="p-2 rounded-lg hover:bg-gray-100"
          >
            <Menu size={22} />
          </button>

          <h1 className="font-semibold text-gray-800">
            LSP Dashboard
          </h1>

          <div className="w-10" />
        </div>

        {/* DESKTOP NAVBAR */}
        <div className="hidden lg:block">
          <TopNavbar />
        </div>

        {/* PAGE CONTENT */}
        <main
          className="
            flex-1
            overflow-y-auto
            p-4
            md:p-6
            lg:p-8
          "
        >
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="tools" element={<Tools />} />
            <Route
              path="announcements"
              element={<Announcements />}
            />
            <Route
              path="wifi"
              element={<WifiPasswords />}
            />
            <Route
                path="cadence-license"
                element={<CadenceLicense />}
            />
            {/*<Route
              path="sessions"
              element={<LearningHub />}
            />
            <Route
              path="knowledge-hub"
              element={<KnowledgeHub />}
            />
            <Route
              path="/attendance"
              element={<AttendanceDashboard />}
            />*/}
          </Routes>
        </main>

      </div>
    </div>
  );
}

export default DashboardLayout;